import React, { useEffect, useState } from 'react';

import Lottie from 'lottie-react';

import './GenerationIcon.scss';

interface props {
    classes?: string;
    generation?: number;
}

const rendererSettings = {
    preserveAspectRatio: 'xMidYMid meet',
};

export const GenerationIcon = (props: props) => {
    const classes = props.classes || '';
    const generation = props.generation || 0;
    const [animationData, setAnimationData] = useState<object>();

    useEffect(() => {
        (async () => {
            const _animationData = await import(`@pkg/lotties/generation-icon-${generation}.json`);

            if (_animationData) {
                setAnimationData(_animationData.default);
            }
        })();
    }, [generation]);

    return (
        <div className={`generation-icon generation-icon--generation-${generation} ${classes}`}>
            {animationData && (
                <Lottie
                    animationData={animationData}
                    autoplay={true}
                    loop={false}
                    rendererSettings={rendererSettings}
                />
            )}
        </div>
    );
};
